export const REMOVE_CONTEUDOS = 'REMOVE_CONTEUDOS';
export const SET_CONTEUDOS = 'SET_CONTEUDOS';
export const ADD_CONTEUDOS = 'ADD_CONTEUDOS';
export const UPDATE_CONTEUDOS = 'UPDATE_CONTEUDOS';